import { combineReducers } from "redux"
import { ConfigOrDepartmentIndexReducer, LoggedInUserReducer, PrintingPDFReducer, SOWReducer, ScreenReducer} from "./Reducers"
export const Reducers = combineReducers({
  screen: ScreenReducer,
	sow: SOWReducer,
	printingPDF: PrintingPDFReducer,
	currentConfigIndex: ConfigOrDepartmentIndexReducer,
	currentDepartmentIndex: ConfigOrDepartmentIndexReducer,
	loggedInUser: LoggedInUserReducer
})